import handleErrors from './handleErrors';
import getAPIPath from '../../js/modules/api-location';

export function trackStream(data) {
  console.log(data);
  return function() {
    return fetch(`${getAPIPath}commandapi/stream/track`, {
      method: 'PUT',
      body: JSON.stringify(data),
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .then((res) => {
      console.log(res);
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/streamActions.js